import * as React                          from 'react';

import { Button                          } from 'src/components/common/button';
import { Dialog                          } from 'src/components/common/dialog';
import { RadioGroup,
         RadioGroupItem                  } from 'src/components/common/radio-group';
import { IconButton                      } from 'src/components/common/icon-button';

import { Container,
         CaptionContainer,
         Caption,
         Close,
         CloseOutlineVectorBig,
         SelectDefectTypeDialogVariants,
         selectdefecttypedialog_variants } from 'src/components/features/inspection/edit/select-defect-type-dialog/ui';

import { DefectType                      } from 'src/services/api/types/inspection';

import { useAppSelector, 
         storeApi,                  
         useAppDispatch                  } from 'src/store';



const radioItems: RadioGroupItem[] = [
  {
    id: 'quality',
    label: 'Качество / сервис'
  },
  {
    id: 'dirty-wagons',
    label: 'Грязные вагоны'
  },
  {
    id: 'term',
    label: 'Сроки'
  },
];

type Props = {
  variant: SelectDefectTypeDialogVariants;
}
export const SelectDefectTypeDialog: React.FC<Props> = ({
  variant,
}) => {
  const lookAndFeel = selectdefecttypedialog_variants.get(variant)!;
  const dispatch = useAppDispatch();

  const [defectType, setDefectType] = React.useState<RadioGroupItem>(radioItems[0]);

  const opened = useAppSelector(storeApi.inspection.edit.selectors.selectDefectSelectTypeOpened);

  const onTapSelectHandler = () => {
    dispatch(storeApi.inspection.edit.actions.defectSelectTypeClosed());

    switch (defectType.id)
    {
      case 'quality':
        dispatch(storeApi.inspection.edit.actions.defectDefectTypeChanged({ from: null, to: DefectType.QUALITY }));
        break;
      case 'dirty-wagons':
        dispatch(storeApi.inspection.edit.actions.defectDefectTypeChanged({ from: null, to: DefectType.DIRTY_WAGONS }));
        break;
      case 'term':
        dispatch(storeApi.inspection.edit.actions.defectDefectTypeChanged({ from: null, to: DefectType.TERM }));
        break;
    }

    dispatch(storeApi.inspection.edit.actions.pieceForEditSelected(null));
  }

  if (!opened)
  {
    return null;
  }

  return (
    <Dialog variant = { lookAndFeel.dialogVariant } isOpened = { opened }>
      <Container lookAndFeel = { lookAndFeel }>
        <CaptionContainer lookAndFeel = { lookAndFeel }>
          <Caption lookAndFeel = { lookAndFeel }>
            Добавить позицию
          </Caption>
          <Close lookAndFeel = { lookAndFeel }>
            <IconButton
              variant = { lookAndFeel.closeButtonVariant }
              isTapAllowed
              onTap = { () => dispatch(storeApi.inspection.edit.actions.defectSelectTypeClosed()) }
            >
              <CloseOutlineVectorBig />
            </IconButton>
          </Close>
        </CaptionContainer>
            <RadioGroup
              variant = { lookAndFeel.radioVariant }
              value = { defectType }
              items = { radioItems }
              onChange = { setDefectType }
            />
            <Button
              variant = { lookAndFeel.buttonVariant }
              label = 'Выбрать'
              onTap = { onTapSelectHandler }
            />
      </Container>
    </Dialog>
  );
};
